import { makeStyles } from '@material-ui/core'

export const useTableStyles = makeStyles((theme) => ({
  '@keyframes tableCellOpen': {
    '0%': {
      transform: 'scale(1, 0)',
      transformOrigin: 'top',
      maxHeight: 0
    },
    '100%': {
      transform: 'scale(1, 1)',
      transformOrigin: 'top',
      maxHeight: '2rem'
    }
  },
  '@keyframes fadey': {
    '0%': {
      opacity: 0.5
    },
    '100%': {
      opacity: 1
    }
  },
  '@keyframes columnSlideIn': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  presentationTableRC: ({ depthStyles, singleLevel }) => ({
    padding: '0',
    display: 'block',
    minWidth: 0,
    '& .__table': {
      fontSize: '0.85rem',
      borderSpacing: 0,
      '& .__thead': {
        position: 'sticky',
        top: ({ superHeaderRect }) =>
          superHeaderRect ? superHeaderRect.height : 0,
        boxShadow: '0px 6px 12px 12px #FFFFFF',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginBottom: '12px'
      },
      '& .__headerGroup': {
      },
      '& .__th': {
        fontWeight: '800',
        fontSize: '0.875rem',
        padding: '8px 20px 8px 12px',
        userSelect: 'none',
        borderLeft: '1px solid rgba(0,0,0,.1)',
        borderRight: '1px solid rgba(0,0,0,0.0)',
        backgroundColor: 'var(--tc-table-header-bg-color)',
        lineHeight: '30px',
        marginBottom: '-1px',
        '&:first-child': {
          borderLeft: '1px solid rgba(0,0,0,0.0)'
        },
        '&.__right': {
          textAlign: 'right'
        },
        '&.__center': {
          textAlign: 'center'
        },
        '&.__left': {
          textAlign: 'left'
        },
        '&.__depth_0:has(.__date-range-selector)': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        '&.__depth_1': {
          padding: '4px 20px 6px 12px',
          borderLeft: '1px solid rgba(0,0,0,0.0)',
          borderRight: '1px solid rgba(0,0,0,0.0)',
          '&:nth-child(even)': {
            borderLeft: '1px solid rgba(0,0,0,0.1)'
          },
          borderBottom: '2px solid #212945'
        },
        '& .__th-content': {
          display: 'flex',
          alignItems: 'center'
        }
      },
      '& .__tbody': {
        overflowX: 'hidden' // rec
      },
      '& .__tr': {},
      '& .__tr:hover .__tr-wrapper': {
        backgroundColor: 'rgba(0, 0, 30, .1)',
        transition: 'background-color .5s ease-in-out .2s'
      },
      '& .__tr.__child': {
        animation: '$tableCellOpen .2s ease-in-out'
      },
      '& .__tr.__depth_0 .__td': {
        fontWeight: singleLevel ? 'inherit' : '800',
        ...(depthStyles?.[0] ?? {})
      },
      '& .__tr.__depth_1': {
        backgroundColor: 'var(--color-neutral-100)',
        '& .__td': depthStyles?.[1] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '18px'
        }
      },
      '& .__tr.__depth_2': {
        backgroundColor: 'var(--color-neutral-200)',
        '& .__td': depthStyles?.[2] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '36px'
        }
      },
      '& .__tr.__depth_3': {
        backgroundColor: 'var(--color-neutral-300)',
        '& .__td': depthStyles?.[3] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '54px'
        }
      },
      '& .__tr.__depth_4': {
        backgroundColor: 'var(--color-neutral-400)',
        '& .__td': depthStyles?.[4] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '72px'
        }
      },
      '& .__td': {
        textAlign: 'left',
        padding: '6px 20px 6px 12px',
        fontWeight: '400',
        transition: 'background-color .2s ease-in-out 0s',
        '&.__right': {
          textAlign: 'right'
        },
        '&:nth-child(even)': {
          borderLeft: '1px solid rgba(0,0,0,0.1)'
        },
        '& .__cell': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      '& .__expand-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:first-child': {
          margin: '0 8px 0 0'
        },
        '& .__expand-item': {
          overflow: 'hidden'
        }
      },
      '& .__expand-handle': {
        animation: '$fadey .25s ease-in-out'
      },
      '& .__sort-icon': {
        padding: '0 0px 0 2px',
        '& .MuiSvgIcon-root': {
          transform: 'translateY(3px)'
        }
      },
      '& .__benchmark': {
        color: 'var(--text-color-main)',
        paddingTop: '4px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%'
      }
    },
    '& .__sticky': {
      overflow: ({ hasHorizontalOverflow }) =>
        hasHorizontalOverflow ? 'auto' : 'unset',
      '& .__thead': {
        position: 'sticky',
        overflowX: 'unset !important',
        overflowY: 'unset !important',
        zIndex: 1,
        top: 0,
        boxShadow: '0px 3px 3px #ccc'
      },
      '& .__tbody': {
        position: 'relative',
        overflowX: 'unset !important',
        zIndex: 0
      },
      '& [data-sticky-td]': {
        position: 'sticky !important'
      },
      '& [data-sticky-last-left-td]': {
        borderRight: '1px solid rgba(0,0,0,0.0)'
      },
      '& [data-sticky-first-right-td]': {
        borderLeft: '1px solid rgba(0,0,0,.1)'
      },
      '& .__tr.__depth_0 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--color-neutral-050)'
      },
      '& .__tr.__depth_1 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--color-neutral-100)'
      },
      '& .__tr.__depth_2 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--color-neutral-200)'
      },
      '& .__tr.__depth_3 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--color-neutral-300)'
      },
      '& .__tr.__depth_4 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--color-neutral-400)'
      }
    },
    '& .__color-icon': {
      minHeight: '12px',
      minWidth: '12px',
      maxWidth: '12px',
      maxHeight: '12px',
      marginRight: '5px',
      border: `.5px solid ${'var(--color-neutral-600)'}`
    }
  }),

  default: ({ depthStyles, singleLevel }) => ({
    padding: '0',
    display: 'block',
    minWidth: 0,
    '& .__table': {
      fontSize: '0.85rem',
      borderSpacing: 0,
      '& .__thead': {
        position: 'sticky',
        top: ({ superHeaderRect }) =>
          superHeaderRect ? superHeaderRect.height : 0,
        boxShadow: '0px 6px 12px 12px var(--tc-table-body-bg-color-d0)',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginBottom: '12px',
        borderBottom: '3px solid var(--color-neutral-700)'
      },
      '& .__headerGroup .__th.__first': {
        borderLeft: '1px solid var(--color-neutral-200)'
      },
      '& .__headerGroup .__th.__last': {
        borderRight: '1px solid var(--color-neutral-200)'
      },
      '& .__th': {
        fontWeight: '800',
        fontSize: '0.875rem',
        padding: '8px 20px 8px 12px',
        userSelect: 'none',
        borderCollapse: 'separate',
        borderSpacing: 0,
        borderLeft: '1px solid var(--color-neutral-200)',
        borderRight: '1px solid var(--color-neutral-200)',
        backgroundColor: 'var(--tc-table-header-bg-color)',
        lineHeight: '30px',
        marginBottom: '-1px',
        '&.__right': {
          textAlign: 'right'
        },
        '&.__center': {
          textAlign: 'center'
        },
        '&.__left': {
          textAlign: 'left'
        },
        '&.__depth_0:last-child': {
          borderRight: 'none'
        },
        '&.__depth_1': {
          padding: '4px 20px 6px 12px',
          border: 'none'
        },
        '& .__th-content': {
          display: 'flex',
          alignItems: 'center'
        }
      },
      '& .__tbody': {
        overflowX: 'hidden' // rec
      },
      '& .__tr': {
        '& .__td.__first': {
          borderLeft: '1px solid var(--color-neutral-200)'
        }
      },
      '& .__tr:hover .__tr-wrapper': {
        backgroundColor: 'rgba(0, 0, 30, .1)',
        transition: 'background-color .5s ease-in-out .2s'
      },
      '& .__tr.__child': {
        animation: '$tableCellOpen .2s ease-in-out'
      },
      '& .__tr.__depth_0 .__td': {
        fontWeight: singleLevel ? 'inherit' : '800',
        backgroundColor: 'var(--tc-table-body-bg-color-d0)',
        ...(depthStyles?.[0] ?? {})
      },
      '& .__tr.__depth_1': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)',
        '& .__td': depthStyles?.[1] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '18px'
        }
      },
      '& .__tr.__depth_2': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)',
        '& .__td': depthStyles?.[2] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '36px'
        }
      },
      '& .__tr.__depth_3': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)',
        '& .__td': depthStyles?.[3] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '54px'
        }
      },
      '& .__tr.__depth_4': {
        backgroundColor: 'var(--tc-table-body-bg-color-d4)',
        '& .__td': depthStyles?.[4] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '72px'
        }
      },
      '& .__td': {
        textAlign: 'left',
        padding: '6px 20px 6px 12px',
        fontWeight: '400',
        transition: 'background-color .2s ease-in-out 0s',
        '&.__right': {
          textAlign: 'right'
        },
        '& .__cell': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      '& .__expand-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:first-child': {
          margin: '0 8px 0 0'
        },
        '& .__expand-item': {
          overflow: 'hidden'
        }
      },
      '& .__expand-handle': {
        animation: '$fadey .25s ease-in-out'
      },
      '& .__sort-icon': {
        padding: '0 0px 0 2px',
        '& .MuiSvgIcon-root': {
          transform: 'translateY(3px)'
        }
      },
      '& .__benchmark': {
        color: 'var(--text-color-main)',
        paddingTop: '4px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%'
      }
    },
    '& .__sticky': {
      overflow: ({ hasHorizontalOverflow }) =>
        hasHorizontalOverflow ? 'auto' : 'unset',
      '& .__thead': {
        position: 'sticky',
        overflowX: 'unset !important',
        overflowY: 'unset !important',
        zIndex: 1,
        top: 0,
        boxShadow: '0px 3px 3px #ccc'
      },
      '& .__tbody': {
        position: 'relative',
        overflowX: 'unset !important',
        zIndex: 0
      },
      '& [data-sticky-td]': {
        position: 'sticky !important'
      },
      '& [data-sticky-last-left-td]': {
        borderRight: '1px solid rgba(0,0,0,0.0)'
      },
      '& [data-sticky-first-right-td]': {
        borderLeft: '1px solid rgba(0,0,0,.1)'
      },
      '& .__tr.__depth_0 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_1 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_2 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)'
      },
      '& .__tr.__depth_3 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)'
      },
      '& .__tr.__depth_4 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)'
      }
    },
    '& .__color-icon': {
      minHeight: '12px',
      minWidth: '12px',
      maxWidth: '12px',
      maxHeight: '12px',
      marginRight: '5px',
      border: `.5px solid ${'var(--color-neutral-600)'}`
    }
  }),

  flat: ({ depthStyles, singleLevel }) => ({
    padding: '0',
    display: 'block',
    minWidth: 0,
    '& .__table': {
      fontSize: '0.85rem',
      borderSpacing: 0,
      '& .__thead': {
        position: 'sticky',
        top: ({ superHeaderRect }) =>
          superHeaderRect ? superHeaderRect.height : 0,
        boxShadow: '0px 6px 12px 12px var(--tc-table-body-bg-color-d0)',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginBottom: '12px',
        borderBottom: '3px solid var(--color-neutral-700)'
      },
      '& .__th': {
        fontWeight: '800',
        fontSize: '0.875rem',
        padding: '8px 20px 8px 12px',
        userSelect: 'none',
        borderCollapse: 'separate',
        borderSpacing: 0,
        backgroundColor: 'var(--tc-table-header-bg-color)',
        lineHeight: '30px',
        marginBottom: '-1px',
        '&.__right': {
          textAlign: 'right'
        },
        '&.__center': {
          textAlign: 'center'
        },
        '&.__left': {
          textAlign: 'left'
        },
        '&.__depth_0:has(.__date-range-selector)': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        '&.__depth_1': {
          padding: '4px 20px 6px 12px',
          border: 'none'
        },
        '& .__th-content': {
          display: 'flex',
          alignItems: 'center'
        }
      },
      '& .__tbody': {
        overflowX: 'hidden' // rec
      },
      '& .__tr': {
      },
      '& .__tr:hover .__tr-wrapper': {
        backgroundColor: 'rgba(0, 0, 30, .1)',
        transition: 'background-color .5s ease-in-out .2s'
      },
      '& .__tr.__child': {
        animation: '$tableCellOpen .2s ease-in-out'
      },
      '& .__tr.__depth_0 .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)',
        fontWeight: singleLevel ? 'inherit' : '800',
        ...(depthStyles?.[0] ?? {})
      },
      '& .__tr.__depth_1': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)',
        '& .__td': depthStyles?.[1] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '18px'
        }
      },
      '& .__tr.__depth_2': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)',
        '& .__td': depthStyles?.[2] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '36px'
        }
      },
      '& .__tr.__depth_3': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)',
        '& .__td': depthStyles?.[3] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '54px'
        }
      },
      '& .__tr.__depth_4': {
        backgroundColor: 'var(--tc-table-body-bg-color-d4)',
        '& .__td': depthStyles?.[4] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '72px'
        }
      },
      '& .__td': {
        textAlign: 'left',
        padding: '6px 20px 6px 12px',
        fontWeight: '400',
        transition: 'background-color .2s ease-in-out 0s',
        '&.__right': {
          textAlign: 'right'
        },
        '& .__cell': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      '& .__expand-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:first-child': {
          margin: '0 8px 0 0'
        },
        '& .__expand-item': {
          overflow: 'hidden'
        }
      },
      '& .__expand-handle': {
        animation: '$fadey .25s ease-in-out'
      },
      '& .__sort-icon': {
        padding: '0 0px 0 2px',
        '& .MuiSvgIcon-root': {
          transform: 'translateY(3px)'
        }
      },
      '& .__benchmark': {
        color: 'var(--text-color-main)',
        paddingTop: '4px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%'
      }
    },
    '& .__sticky': {
      overflow: ({ hasHorizontalOverflow }) =>
        hasHorizontalOverflow ? 'auto' : 'unset',
      '& .__thead': {
        position: 'sticky',
        overflowX: 'unset !important',
        overflowY: 'unset !important',
        zIndex: 1,
        top: 0,
        boxShadow: '0px 3px 3px var(--tc-table-body-bg-color-d0)'
      },
      '& .__tbody': {
        position: 'relative',
        overflowX: 'unset !important',
        zIndex: 0
      },
      '& [data-sticky-td]': {
        position: 'sticky !important'
      },
      '& [data-sticky-last-left-td]': {
        borderRight: '1px solid rgba(0,0,0,0.0)'
      },
      '& [data-sticky-first-right-td]': {
        borderLeft: '1px solid rgba(0,0,0,.1)'
      },
      '& .__tr.__depth_0 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_1 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_2 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)'
      },
      '& .__tr.__depth_3 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)'
      },
      '& .__tr.__depth_4 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)'
      }
    },
    '& .__color-icon': {
      minHeight: '12px',
      minWidth: '12px',
      maxWidth: '12px',
      maxHeight: '12px',
      marginRight: '5px',
      border: `.5px solid ${'var(--color-neutral-300)'}`
    }
  }),

  glass: ({ depthStyles, singleLevel, glassFactor = 0.85 }) => ({
    padding: '0',
    display: 'block',
    minWidth: 0,
    '& .__table': {
      fontSize: '0.85rem',
      borderSpacing: 0,
      border: `1px solid color-mix(in srgb, var(--color-neutral-900) ${glassFactor / 2}%, transparent)`,
      borderRadius: 'var(--border-radius-sm)',
      boxShadow: 'var(--shadow-md)',
      '& .__thead': {
        position: 'sticky',
        top: ({ superHeaderRect }) =>
          superHeaderRect ? superHeaderRect.height : 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        borderBottom: `2px solid color-mix(in srgb, var(--color-neutral-900) ${(glassFactor * 100) / 2}%, transparent)`
      },
      '& .__th': {
        fontWeight: '800',
        fontSize: '0.875rem',
        padding: '8px 20px 8px 12px',
        userSelect: 'none',
        borderCollapse: 'separate',
        borderSpacing: 0,
        backgroundColor: `color-mix(in srgb, var(--tc-table-header-bg-color) ${glassFactor * 100}%, transparent)`,
        lineHeight: '30px',
        marginBottom: '-1px',
        '&.__right': {
          textAlign: 'right'
        },
        '&.__center': {
          textAlign: 'center'
        },
        '&.__left': {
          textAlign: 'left'
        },
        '&.__depth_0:has(.__date-range-selector)': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        '&.__depth_1': {
          padding: '4px 20px 6px 12px',
          border: 'none'
        },
        '& .__th-content': {
          display: 'flex',
          alignItems: 'center'
        },
        '&:first-child': {
          borderTopLeftRadius: theme.layout.radius.tight
        },
        '&:last-child': {
          borderTopRightRadius: theme.layout.radius.tight
        }
      },
      '& .__tbody': {
        overflowX: 'hidden' // rec
      },
      '& .__tr': {
      },
      '& .__tr:last-child': {
        borderBottomLeftRadius: theme.layout.radius.tight,
        borderBottomRightRadius: theme.layout.radius.tight
      },
      '& .__tr:last-child .__td:first-child': {
        borderBottomLeftRadius: theme.layout.radius.tight
      },
      '& .__tr:last-child .__td:last-child': {
        borderBottomRightRadius: theme.layout.radius.tight
      },
      '& .__tr:hover .__tr-wrapper': {
        backgroundColor: `color-mix(in srgb, var(--color-primary-500) ${glassFactor * 100}%, transparent)`,
        transition: 'background-color .5s ease-in-out .2s'
      },
      '& .__tr:last-child .__tr-wrapper': {
        '&:first-child': {
          borderBottomLeftRadius: theme.layout.radius.tight
        },
        '&:last-child': {
          borderBottomRightRadius: theme.layout.radius.tight
        }
      },
      '& .__tr.__child': {
        animation: '$tableCellOpen .2s ease-in-out'
      },
      '& .__tr.__depth_0 .__td': {
        fontWeight: singleLevel ? 'inherit' : '800',
        ...(depthStyles?.[0] ?? {})
      },
      '& .__tr.__depth_1': {
        '& .__td': depthStyles?.[1] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '18px'
        }
        // '&:nth-child(2n)': {
        //   backgroundColor: alpha('var(--color-neutral-700)', 0.8)
        // }
      },
      '& .__tr.__depth_2': {
        '& .__td': depthStyles?.[2] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '36px'
        }
      },
      '& .__tr.__depth_3': {
        '& .__td': depthStyles?.[3] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '54px'
        }
      },
      '& .__tr.__depth_4': {
        '& .__td': depthStyles?.[4] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '72px'
        }
      },
      '& .__td': {
        textAlign: 'left',
        padding: '6px 20px 6px 12px',
        fontWeight: '400',
        transition: 'background-color .2s ease-in-out 0s',
        '&.__right': {
          textAlign: 'right'
        },
        '& .__cell': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      '& .__expand-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:first-child': {
          margin: '0 8px 0 0'
        },
        '& .__expand-item': {
          overflow: 'hidden'
        }
      },
      '& .__expand-handle': {
        animation: '$fadey .25s ease-in-out'
      },
      '& .__sort-icon': {
        padding: '0 0px 0 2px',
        '& .MuiSvgIcon-root': {
          transform: 'translateY(3px)'
        }
      },
      '& .__benchmark': {
        color: 'var(--text-color-main)',
        paddingTop: '4px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%'
      }
    },
    '& .__sticky': {
      overflow: ({ hasHorizontalOverflow }) =>
        hasHorizontalOverflow ? 'auto' : 'unset',
      '& .__thead': {
        position: 'sticky',
        overflowX: 'unset !important',
        overflowY: 'unset !important',
        zIndex: 1,
        top: 0
      },
      '& .__tbody': {
        position: 'relative',
        overflowX: 'unset !important',
        zIndex: 0
      },
      '& [data-sticky-td]': {
        position: 'sticky !important'
      },
      '& [data-sticky-last-left-td]': {
        borderRight: '1px solid rgba(0,0,0,0.0)'
      },
      '& [data-sticky-first-right-td]': {
        borderLeft: '1px solid rgba(0,0,0,.1)'
      },
      '& .__tr.__depth_0 > .__tr-wrapper > .__td': {
        backgroundColor: `color-mix(in srgb, var(--tc-table-body-bg-color-d0) ${glassFactor * 100}%, transparent)`
      },
      '& .__tr.__depth_1 > .__tr-wrapper > .__td': {
        backgroundColor: `color-mix(in srgb, var(--tc-table-body-bg-color-d0) ${glassFactor * 100}%, transparent)`
      },
      '& .__tr.__depth_2 > .__tr-wrapper > *.__td': {
        backgroundColor: `color-mix(in srgb, var(--tc-table-body-bg-color-d0) ${glassFactor * 100}%, transparent)`
      },
      '& .__tr.__depth_3 > .__tr-wrapper > *.__td': {
        backgroundColor: `color-mix(in srgb, var(--tc-table-body-bg-color-d0) ${glassFactor * 100}%, transparent)`
      },
      '& .__tr.__depth_4 > .__tr-wrapper > *.__td': {
        backgroundColor: `color-mix(in srgb, var(--tc-table-body-bg-color-d0) ${glassFactor * 100}%, transparent)`
      }
    },
    '& .__color-icon': {
      minHeight: '12px',
      minWidth: '12px',
      maxWidth: '12px',
      maxHeight: '12px',
      marginRight: '5px',
      border: '.5px solid var(--color-neutral-600)'
    }
  }),

  legacy: ({ depthStyles, singleLevel }) => ({
    padding: '0',
    display: 'block',
    minWidth: 0,
    '& .__table': {
      fontSize: '0.85rem',
      borderSpacing: 0,
      '& .__thead': {
        position: 'sticky',
        top: ({ superHeaderRect }) =>
          superHeaderRect ? superHeaderRect.height : 0,
        boxShadow: '0px 6px 12px 12px #FFFFFF',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginBottom: '12px',
        borderBottom: '3px solid var(--color-neutral-700)'
      },
      '& .__headerGroup': {
      },
      '& .__th': {
        fontWeight: '800',
        fontSize: '0.875rem',
        padding: '8px 20px 8px 12px',
        userSelect: 'none',
        borderCollapse: 'separate',
        borderSpacing: 0,
        border: `1px solid ${'var(--color-neutral-200)'}`,
        // borderLeft: '1px solid rgba(0,0,0,.1)',
        // borderRight: '1px solid rgba(0,0,0,0.0)',
        backgroundColor: 'var(--tc-table-header-bg-color)',
        lineHeight: '30px',
        marginBottom: '-1px',
        '&.__right': {
          textAlign: 'right'
        },
        '&.__center': {
          textAlign: 'center'
        },
        '&.__left': {
          textAlign: 'left'
        },
        '&.__depth_0:has(.__date-range-selector)': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        },
        '&.__depth_1': {
          padding: '4px 20px 6px 12px',
          borderLeft: '1px solid rgba(0,0,0,0.0)',
          borderRight: '1px solid rgba(0,0,0,0.0)',
          borderBottom: '2px solid #212945'
        },
        '& .__th-content': {
          display: 'flex',
          alignItems: 'center'
        }
      },
      '& .__tbody': {
        overflowX: 'hidden' // rec
      },
      '& .__tr': {},
      '& .__tr:hover .__tr-wrapper': {
        backgroundColor: 'rgba(0, 0, 30, .1)',
        transition: 'background-color .5s ease-in-out .2s'
      },
      '& .__tr.__child': {
        animation: '$tableCellOpen .2s ease-in-out'
      },
      '& .__tr.__depth_0 .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)',
        fontWeight: singleLevel ? 'inherit' : '800',
        ...(depthStyles?.[0] ?? {})
      },
      '& .__tr.__depth_1': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)',
        '& .__td': depthStyles?.[1] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '18px'
        }
      },
      '& .__tr.__depth_2': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)',
        '& .__td': depthStyles?.[2] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '36px'
        }
      },
      '& .__tr.__depth_3': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)',
        '& .__td': depthStyles?.[3] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '54px'
        }
      },
      '& .__tr.__depth_4': {
        backgroundColor: 'var(--tc-table-body-bg-color-d4)',
        '& .__td': depthStyles?.[4] ?? {},
        '& .__tr-wrapper > *:first-child': {
          paddingLeft: '72px'
        }
      },
      '& .__td': {
        textAlign: 'left',
        padding: '6px 20px 6px 12px',
        fontWeight: '400',
        transition: 'background-color .2s ease-in-out 0s',
        '&.__right': {
          textAlign: 'right'
        },
        '& .__cell': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      },
      '& .__expand-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *:first-child': {
          margin: '0 8px 0 0'
        },
        '& .__expand-item': {
          overflow: 'hidden'
        }
      },
      '& .__expand-handle': {
        animation: '$fadey .25s ease-in-out'
      },
      '& .__sort-icon': {
        padding: '0 0px 0 2px',
        '& .MuiSvgIcon-root': {
          transform: 'translateY(3px)'
        }
      },
      '& .__benchmark': {
        color: 'var(--text-color-main)',
        paddingTop: '4px',
        fontWeight: 'normal',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100%'
      }
    },
    '& .__sticky': {
      overflow: ({ hasHorizontalOverflow }) =>
        hasHorizontalOverflow ? 'auto' : 'unset',
      '& .__thead': {
        position: 'sticky',
        overflowX: 'unset !important',
        overflowY: 'unset !important',
        zIndex: 1,
        top: 0,
        boxShadow: '0px 3px 3px #ccc'
      },
      '& .__tbody': {
        position: 'relative',
        overflowX: 'unset !important',
        zIndex: 0
      },
      '& [data-sticky-td]': {
        position: 'sticky !important'
      },
      '& [data-sticky-last-left-td]': {
        borderRight: '1px solid rgba(0,0,0,0.0)'
      },
      '& [data-sticky-first-right-td]': {
        borderLeft: '1px solid rgba(0,0,0,.1)'
      },
      '& .__tr.__depth_0 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_1 > .__tr-wrapper > .__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d0)'
      },
      '& .__tr.__depth_2 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d1)'
      },
      '& .__tr.__depth_3 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d2)'
      },
      '& .__tr.__depth_4 > .__tr-wrapper > *.__td': {
        backgroundColor: 'var(--tc-table-body-bg-color-d3)'
      }
    },
    '& .__color-icon': {
      minHeight: '12px',
      minWidth: '12px',
      maxWidth: '12px',
      maxHeight: '12px',
      marginRight: '5px',
      border: `.5px solid ${'var(--color-neutral-600)'}`
    },
    '& .__pivot-collapse': {
      overflowX: 'auto',
      '& .__th': {
        display: 'flex',
        width: '100%',
        alignItems: 'center',

        '&.__right': { justifyContent: 'end' },
        '&.__left': { justifyContent: 'start' },
        '&.__center': { justifyContent: 'center' },

        '&.__pivot-child': {
          backgroundColor: 'var(--color-neutral-200)',
          borderColor: 'var(--color-neutral-300)',
          fontSize: '0.9em',
          lineHeight: 1.5,
          display: 'flex',
          alignItems: 'center',
          animation: '$columnSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
        },

        '& .__collapsible-column-header': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
          gap: '4px',

          '& .__header-text': {
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          },
          '& .__collapse-toggle': {
            padding: 'var(--dim-1)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            border: '2px solid transparent',
            transition: 'border .2s ease-in-out',
            borderRadius: 'var(--border-radius-sm)',
            '&:focus': {
              border: '2px solid var(--color-primary-400)'
            }
          }
        }
      },

      '& .__tbody .__tr .__tr-wrapper .__td': {
        '&.__pivot-child': {
          backgroundColor: 'var(--color-neutral-200)',
          borderColor: 'var(--color-neutral-300)',
          fontSize: '0.9em',
          lineHeight: 1.5,
          animation: '$columnSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }
      }
    }
  }),
  sparkRoot: {
    opacity: ({ loading }) => loading ? 1 : 0,
    transition: ({ loading }) => loading ? 'opacity .25s ease-in-out .25s' : 'opacity .1s ease-in-out',
    height: '2px'
  },
  pivotCollapseStyles: {
    '& .__th.__pivot-child': {
      animation: '$columnSlideIn 0.2s ease-in-out'
    },
    '& .__td.__pivot-child': {
      animation: '$columnSlideIn 0.2s ease-in-out'
    }
  }
}))
